import { render, staticRenderFns } from "./GcoinsLoaded.vue?vue&type=template&id=7ee106a8&scoped=true&"
import script from "./GcoinsLoaded.vue?vue&type=script&lang=js&"
export * from "./GcoinsLoaded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee106a8",
  null
  
)

export default component.exports